import "./seconddesc.css";
import React from "react";

function About() {
  return (
    <div className="second">
      <div className="second_content">
        <p>
          Items will be shipped all over India and abroad. Shipping duration
          will vary depending on the region for customers ordering from outside
          India.
        </p>
        <p>Please order well in advance to receive your orders on time.</p>
      </div>
    </div>
  );
}

export default About;
